import { Layout } from "antd";
import clsx from "clsx";
import type { ComponentProps } from "react";
import "./BSider.scss";

type BSiderProps = ComponentProps<typeof Layout.Sider>;

const BSider = ({ className, ...props }: BSiderProps) => (
  <Layout.Sider className={clsx("b-sider", className)} {...props} />
);

export default BSider;
